import { cn } from '@repo/tailwind-config/tailwind.functions'
import { IFile } from '@repo/toolkit/types'
import { useState } from 'react'

import useTranslate from '../../../../../apps/backoffice/src/lib/hooks/use-translate'
import { ChevronLeftIcon, ChevronRightIcon } from '../../../icons'
import Modal from '../modal'

type ImageDisplayerProps = {
  images?: IFile[]
}

export function ImageDisplayer({ images }: ImageDisplayerProps) {
  const { t } = useTranslate()
  const [selectedImage, setSelectedImage] = useState<IFile>()

  if (!images || images.length === 0)
    return <div className="text-center text-grey-dark">{t('common.noImages')}</div>
  return (
    <div className={'flex flex-wrap gap-2 mt-3'}>
      {images.map((picture) => (
        <img
          key={picture.name}
          src={picture.path}
          alt={picture.name}
          className="w-60 h-60 object-cover object-center rounded-lg border border-grey-light cursor-pointer"
          onClick={() => setSelectedImage(picture)}
        />
      ))}

      {selectedImage && (
        <Modal
          hideHeader
          hideActions
          size={'large'}
          isOpen={!!selectedImage}
          onCancel={() => setSelectedImage(undefined)}
        >
          <div className={'p-1'}>
            <div className={'relative'}>
              {images.length > 1 && (
                <>
                  <div
                    className="cursor-pointer duration-100 hover:bg-opacity-45 absolute top-1/2 left-6 p-2 rounded-full border border-grey-light bg-black bg-opacity-30"
                    onClick={() => {
                      const currentIndex = images.indexOf(selectedImage)
                      const nextIndex = (currentIndex - 1 + images.length) % images.length
                      setSelectedImage(images[nextIndex])
                    }}
                  >
                    <ChevronLeftIcon />
                  </div>
                  <div
                    className="absolute cursor-pointer duration-100 hover:bg-opacity-45 top-1/2 right-6 p-2 rounded-full border border-grey-light bg-black bg-opacity-30"
                    onClick={() => {
                      const currentIndex = images.indexOf(selectedImage)
                      const nextIndex = (currentIndex + 1) % images.length
                      setSelectedImage(images[nextIndex])
                    }}
                  >
                    <ChevronRightIcon />
                  </div>
                </>
              )}

              <img
                key={selectedImage.name}
                src={selectedImage.path}
                alt={selectedImage.name}
                className="w-full mobile:h-[50dvh] h-[600px] object-cover object-center rounded-lg border border-grey-light cursor-pointer"
              />
            </div>

            <div className="flex flex-row gap-1 mt-1">
              {images?.map((image) => (
                <div key={image.name} className={'relative'}>
                  <img
                    src={image.path}
                    alt={image.name}
                    className="w-20 h-20 object-cover object-center rounded-lg border border-grey-light"
                  />

                  <div
                    className={cn(
                      'absolute top-0 right-0 w-20 h-20 rounded-lg bg-black opacity-60 cursor-pointer',
                      { hidden: selectedImage.path === image.path }
                    )}
                    onClick={() => setSelectedImage(image)}
                  />
                </div>
              ))}
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}
